<template>
<div class="chapter">
<div class="inner_page">
<a id="p1"></a>
<div class="copyright">
<p class="center ">First Mariner Books edition 2020</p>
<p class="center ">Copyright © 2019 by Kate Davies</p>
<p class="center ">Questions for Discussion © 2020 by Houghton Mifflin Harcourt Publishing Company</p>
<p class="center ">A Conversation with Kate Davies © 2020 by Kate Davies</p>
<p class="center spaceabove1">All rights reserved</p>
<p class="center spaceabove1">For information about permission to reproduce selections from this book, write to <a href="mailto:trade.permissions@hmhco.com">trade.permissions@hmhco.com</a> or to Permissions, Houghton Mifflin Harcourt Publishing Company, 3 Park Avenue, 19th Floor, New York, New York 10016.</p>
<p class="center spaceabove1"><a href="https://hmhbooks.com/" target="_blank">hmhbooks.com</a></p>
<p class="center spaceabove1"><em>Library of Congress Cataloging-in-Publication Data</em></p>
<p class="center ">Names: Davies, Kate, 1983– author.</p>
<p class="center ">Title: In at the deep end / Kate Davies.</p>
<p class="center ">Description: Boston : Houghton Mifflin Harcourt, 2019.</p>
<p class="center ">Identifiers: <span class="smallcaps">LCCN</span> 2018042560 (print) | <span class="smallcaps">LCCN</span> 2018048398 (ebook) | <span class="smallcaps">ISBN</span> 9781328628657 (ebook) | <span class="smallcaps">ISBN</span> 9781328629678 (hardback) | <span class="smallcaps">ISBN</span> 978-0-358-29959-2 (pbk.)</p>
<p class="center ">Subjects: | <span class="smallcaps">BISAC: FICTION</span> / Contemporary Women. | <span class="smallcaps">FICTION</span> / Humorous. | <span class="smallcaps">FICTION</span> / Lesbian.</p>
<p class="center ">Classification: <span class="smallcaps">LCC</span> <span class="smallcaps">PR</span>6104.<span class="smallcaps">A</span>8648 (ebook) | <span class="smallcaps">LCC PR</span>6104.<span class="smallcaps">A</span>8648 <span class="smallcaps">I</span>5 2019 (print) |</p>
<p class="center "><span class="smallcaps">DDC</span> 823/.92—<span class="smallcaps">DC</span>23</p>
<p class="center ">LC record available at <a href="https://lccn.loc.gov/2018042560" target="_blank">https://lccn.loc.gov/2018042560</a></p>
<p class="center spaceabove1">Cover design by Micaela Alcaino © HarperCollinsPublishers Ltd 2019</p>
<p class="center ">Cover photograph © Ros Roberts / Getty images</p>
<p class="center ">Author photograph © Idil Sukan / Hardy Towers</p>
<p class="center spaceabove1">v2.0520</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front01.vue?5492acb6